import React from 'react'
//import Navbar from '../components/landingPage/header/Navbar'
import Footer from '../components/landingPage/footer/ErrorPageFooter'
import { Outlet } from 'react-router-dom'

// Error pages layout

const ErrorPageLayout = () => {
  return (
    <>
      {/* <Navbar /> */}
      <div className="min-h-[calc(100vh_-_30vh)]">
        <Outlet />
      </div>
      <Footer />
    </>
  )
}

export default ErrorPageLayout
